var _rect, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsGlassIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 45,
    height: 45,
    rx: 5,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_406_160)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 5,
    transform: "matrix(-1 0 0 1 45 6)",
    fill: "#E2DFFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: 0.25,
    width: 44.5,
    height: 44.5,
    rx: 4.75,
    transform: "matrix(-1 0 0 1 44.5 6)",
    stroke: "url(#paint0_linear_406_160)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0989 28.6924C14.9346 26.4186 16.0377 24.4866 17.0374 23.3744C17.5035 22.8559 18.3383 22.2282 19.1265 21.8368C19.9744 21.4159 20.9616 21.1592 22.0167 21.0983C22.8438 21.0505 24.2951 21.3428 25.0816 21.6807C26.0375 22.0914 27.1454 22.8271 27.7077 23.5316C28.1814 24.1251 28.4212 24.3572 28.8193 25.1623C31.1119 29.7983 27.8993 35.2819 22.682 35.5534C21.9029 35.5939 21.9255 35.6546 21.0335 35.4915C20.5151 35.3967 20.0671 35.2684 19.6029 35.0758C16.9255 33.9649 15.3118 31.6383 15.0989 28.6924ZM34.7091 25.6239V25.7002C34.6872 25.7847 33.8816 26.4452 33.7368 26.5618L33.1924 27.0309C32.2313 27.7831 32.4891 27.5666 32.4891 29.1267C32.645 29.1683 33.4111 29.8794 33.6062 30.0365C33.789 30.1838 33.9592 30.3551 34.1444 30.5118L34.7091 30.9606C34.7003 31.3558 34.1391 32.9304 33.9865 33.2784C33.8271 33.642 33.6732 33.9474 33.5026 34.2905C33.4092 34.4784 33.3395 34.6027 33.2283 34.7884C33.1433 34.9302 33.0114 35.1071 32.9717 35.2557C32.4985 35.1455 31.6084 35.1706 31.0209 35.083C29.5815 34.8686 30.0988 35.1224 29.2481 35.779C29.139 35.8632 29.0452 35.9271 29.0171 36.0801C28.9855 36.252 29.2074 38.402 29.2074 38.9717C28.6215 39.3641 27.936 39.6918 27.2454 40.0018C27.0449 40.0918 25.3998 40.6712 25.0591 40.7091H25.0088L24.0098 39.5846C23.9067 39.4628 23.8782 39.4178 23.7662 39.2974C23.6582 39.1811 23.6379 39.1266 23.5249 39.0079C23.4082 38.8853 23.1397 38.4891 22.9819 38.4891C21.1824 38.4891 21.8389 38.3335 20.9428 39.2974L20.2107 40.1578C19.6219 40.9115 19.7295 40.7183 19.083 40.5542C17.9254 40.2602 16.4445 39.6031 15.5016 38.9717C15.5016 38.2876 15.595 37.6235 15.6435 36.9902C15.6583 36.7986 15.7171 36.1199 15.6712 36.0034C15.6258 35.8883 15.2702 35.636 15.1506 35.5103C14.9906 35.3421 14.8599 35.0323 14.5846 35.0113C14.3889 34.9964 14.3335 35.057 14.1026 35.0631L11.7374 35.2557L11.1904 34.2583C10.8843 33.6441 10.0157 31.6631 10 30.9606C10.3558 30.7223 10.7779 30.3045 11.1379 30.0233L12.1244 29.176C12.1919 29.1098 12.22 29.1779 12.22 29.0302C12.22 27.3167 12.4629 27.8316 11.1244 26.6993C10.8399 26.4585 10.2829 25.9379 10 25.7485C10.007 25.4344 10.2166 24.8602 10.3063 24.5588C10.5969 23.5831 11.2047 22.2971 11.7374 21.5016C12.4042 21.5016 13.1179 21.5741 13.7232 21.6392C14.9254 21.7685 14.63 21.7241 15.2 21.1517C15.5557 20.7945 15.6803 20.8281 15.698 20.5848L15.6114 19.6545C15.5671 19.3232 15.572 18.9907 15.5467 18.6575C15.5275 18.4041 15.4744 17.99 15.4534 17.7374C16.1147 17.3874 16.7186 16.9965 17.4593 16.7029C17.9151 16.5222 19.3028 16.0099 19.7485 16C19.836 16.1307 19.8613 16.1807 19.9776 16.3017L21.4244 17.9918C21.6164 18.2144 21.5456 18.22 21.6789 18.22C23.4702 18.22 22.9001 18.4071 23.5497 17.6778C23.7197 17.4871 23.854 17.3373 24.0157 17.1303C24.1725 16.9297 24.3475 16.7588 24.5118 16.5647L24.9606 16C25.2866 16.0073 25.8727 16.2192 26.195 16.3098C27.3267 16.628 28.3051 17.2343 29.2557 17.7374C28.9136 21.8484 28.8467 20.22 29.7934 21.4466C29.8927 21.5753 29.8939 21.6587 30.0797 21.6924C30.2522 21.7236 32.4 21.5016 32.9717 21.5016C33.3125 22.0105 33.7619 22.8429 34.0062 23.4593C34.1102 23.7217 34.6631 25.2274 34.7091 25.6239Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1218 28.361C19.1218 27.893 19.246 27.4431 19.4207 27.033C19.6993 26.3792 20.3914 25.6637 21.0424 25.4006C22.3447 24.8743 23.6697 25.0812 24.6626 26.0742C25.9429 27.3544 25.9384 29.3721 24.6626 30.6478C23.8817 31.4288 22.7576 31.7716 21.6743 31.521C20.1748 31.1741 19.1218 29.8368 19.1218 28.361ZM16.94 28.6141C17.0995 30.8212 18.3085 32.5642 20.3143 33.3965C20.6621 33.5408 20.9978 33.6369 21.3861 33.7079C22.0544 33.8301 22.0375 33.7846 22.6211 33.7543C26.5298 33.5509 28.9367 29.4426 27.2191 25.9694C26.9208 25.3663 26.7412 25.1924 26.3863 24.7477C25.9651 24.2199 25.135 23.6688 24.4188 23.3611C23.8297 23.108 22.7424 22.889 22.1227 22.9247C21.3322 22.9704 20.5927 23.1627 19.9574 23.4781C19.3669 23.7712 18.7414 24.2415 18.3923 24.63C17.6433 25.4632 16.8169 26.9106 16.94 28.6141Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_406_160",
    x: -8,
    y: -2,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_406_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_406_160",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_160",
    x1: 75.5,
    y1: 21.5,
    x2: 40,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C60F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsGlassIcon2);
export default __webpack_public_path__ + "static/media/settings-glass-icon2.8d24b679ba9b58b28de6cff25a4553da.svg";
export { ForwardRef as ReactComponent };